export default __webpack_public_path__ + "static/media/produto-quarenta-graus.df695522.png";